import React from 'react';
import {
  FaFacebookF,
  FaInstagram,
  FaYoutube,
  FaLinkedinIn,
  FaTwitter,
  FaPaperPlane,
} from 'react-icons/fa';
import './footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="footer-container">
          {/* Brand Info */}
          <div className="footer-col brand-col">
            <h2 className="footer-logo">
              Luxory <span>Studios</span>
            </h2>
            <p className="footer-tagline">DIGITAL CASTING AGENCY</p>
            <p className="footer-desc">
              Bridging the gap between talented aspiring artists and premier casting
              directors, production houses, and modeling opportunities across the nation.
            </p>
            <div className="social-links">
              <a href="#" aria-label="Facebook"><FaFacebookF /></a>
              <a href="#" aria-label="Instagram"><FaInstagram /></a>
              <a href="#" aria-label="YouTube"><FaYoutube /></a>
              <a href="#" aria-label="LinkedIn"><FaLinkedinIn /></a>
              <a href="#" aria-label="Twitter"><FaTwitter /></a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-col">
            <h3 className="footer-heading">Quick Links</h3>
            <ul className="footer-list">
              <li><a href="#home">Home</a></li>
              <li><a href="#about">About Us</a></li>
              <li><a href="#our-team">Our Team</a></li>
              <li><a href="#success">Success Stories</a></li>
              <li><a href="#contact">Contact Us</a></li>
            </ul>
          </div>

          {/* Casting Categories */}
          <div className="footer-col">
            <h3 className="footer-heading">Categories</h3>
            <ul className="footer-list">
              <li><a href="#actors">Actors</a></li>
              <li><a href="#models">Models</a></li>
              <li><a href="#child-artists">Child Artists</a></li>
              <li><a href="#plus-size">Plus Size Models</a></li>
              <li><a href="#auditions">Latest Auditions</a></li>
            </ul>
          </div>

          {/* Newsletter / Stay Connected */}
          <div className="footer-col newsletter-col">
            <h3 className="footer-heading">Stay Updated</h3>
            <p className="newsletter-text">
              Subscribe to get updates on upcoming auditions, casts, and talent searches.
            </p>
            <form className="newsletter-form" onSubmit={(e) => e.preventDefault()}>
              <input
                type="email"
                placeholder="Enter your email"
                className="newsletter-input"
                required
              />
              <button type="submit" className="newsletter-btn" aria-label="Subscribe">
                <FaPaperPlane />
              </button>
            </form>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="footer-bottom">
        <div className="footer-bottom-container">
          <p>© {new Date().getFullYear()} Cast You. All Rights Reserved.</p>
          <div className="legal-links">
            <a href="#terms">Terms & Conditions</a>
            <span className="dot">•</span>
            <a href="#privacy">Privacy Policy</a>
            <span className="dot">•</span>
            <a href="#disclaimer">Disclaimer</a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;